export function deleteLayers(map, filter) {
    map.pm
        .getGeomanLayers()
        .filter(filter)
        .forEach((layer) => {
            layer.remove();
        });
}
